<template>
	<div v-if="id">
		<v-row v-if="survey && survey.active">
			<v-col cols="12" :sm="survey.removeAbout ? 12 : 9">
				<v-card v-if="survey && survey.active">
					<v-card-title></v-card-title>
					<div v-if="!completed">
						<v-card-text v-if="survey.introText" v-html="survey.introText"></v-card-text>
					</div>
					<div v-else>
						<h2 class="mw-h1 text-green ma-3 pt-4">Thank you!</h2>
					</div>
					<DisplaySurvey :surveyContent="surveyContent" v-on:complete="complete" :data="data"></DisplaySurvey>
				</v-card>
				<v-dialog v-model="dialog" width="360px">
					<v-card>
						<v-card-title>Existing Data</v-card-title>
						<v-card-text>
							You have already provided some answers to this survey, would you like to retrieve your data or start fresh?
						</v-card-text>
						<v-card-actions>

							<v-btn color="primary" @click="dialog = 0">Start Fresh</v-btn>
							<v-btn @click="setData" color="accent">Load Existing Data</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-col>
			<v-col cols="12" sm="3" v-if="!survey.removeAbout">
				<h2 class="mw-h2 text-green ml-2">About</h2>
				<div class="pa-2"><p>Meisterworks conduct research in conjunction with government organisations, companies and charities in order to learn about how they and/or their products or services are doing, and how they could be improved. Sometimes, we do this by asking specific questions about brands, services or products; at other times, we’ll show you  designs, ideas or prototypes to see what you think about them. We're always driven to include the views and opinions of individuals from a broad range of backgrounds, and the questions on this page help us do that - thank you for answering them diligently!</p> </div>
				<v-btn block link color="primary" class="mb-2" href="https://m.works">About Meiserworks</v-btn>
				<v-btn block link color="green" dark href="/contact">Contact Us</v-btn>
			</v-col>
		</v-row>
		<v-card v-else class="pa-5 mt-5">
			<p class="font-weight-thin text-large">
				Survey not found
			</p>
		</v-card>
	</div>
</template>

<script type="text/javascript">
	import Vuex from 'vuex';
	import DisplaySurvey from "../components/tools/DisplaySurvey";
	export default{
		name: "Survey", 
		data: () => {
			return {
				id: false,
				dialog: false,
				data: false,
				update: false,
				completed: false
			}
		},
		components: {
			DisplaySurvey: DisplaySurvey,
		},
		computed: {
			...Vuex.mapState({
				view: state => state.auth.view,
				user: state => state.auth.user,
				survey: state => state[ state.auth.view ].survey,
			}),
			surveyContent(){
				let content = {
					elements: []
				}
				let self = this;
				self.survey.elements.forEach( e => content.elements.push(e) )
				content.completedHtml = self.survey.thankYouMessage				
				content.showQuestionNumbers = self.survey.showQuestionNumbers				
				for( var key in self.survey.surveyProperties ){
					content[key] = self.survey.surveyProperties[key];
				}

				return content;
			}
		},
		methods: {
			setData(){
				const self = this;
				if( !self.survey.response.data ){ return }
				self.data = self.survey.response.data;
				self.update = true;
				self.dialog = false;
			},
			complete(result){
				const self = this;
				if( !result.data ){
					return;
				}
				let response = {
					status: "new",
					path: self.$route.path,
					data: result.data, 
					survey: this.id
				}
				if( this.user.uid ){
					response.respondent = this.user.uid; 
					response.type = "panelmember";
					if( !this.update ){

						this.$store.dispatch("addDoc", {
							collection: "surveyResponses", 
							data: response  
						}).then( () => {
							if( self.survey.sendToAfter ){
								self.$router.replace( self.survey.sendToAfter )
								self.$router.go();
							}
						})
					}
					else{
						this.$store.dispatch("updateDoc", {
							doc: "surveyResponses/" + this.survey.response.id , 
							data: response, 
							action: "update"
						}).then( () => {
							if( self.survey.sendToAfter ){
								self.$router.replace( self.survey.sendToAfter )
								self.$router.go();
							}
							else{
								self.completed = true
							}

						})
					}
				}
				else{
					this.$store.dispatch("addDoc", {
						collection: "visitors", 
						data: { firstSurvey: this.id }  
					}).then( (ref) => {
						response.type = "visitor";
						response.respondent = ref.id; 
						this.$store.dispatch("addDoc", {
							collection: "surveyResponses", 
							data: response  
						}).then( () => {
							if( self.survey.sendToAfter ){
								self.$router.replace( {path: self.survey.sendToAfter, query: { visitor: ref.id }} )
								self.$router.go();
							}
							else{
								self.completed = true
							}
							
						})

					} )
				}

			}
		},
		created(){
				const self = this;
				self.id = self.$route.params.id;
				if( !self.id ){
					// redirect
				}
		},
		watch: {
			id: {
				immediate: true,
				handler(id){
					if( !id ){
						return;
					}
					const self = this;	
					self.$store.dispatch( "fetchSurvey", id ).then( () => {
						if( self.survey.allowRetrieveResponses == true && self.survey.response ){
							this.dialog = true;
						}
					})
				}				
			}
		}
	}
</script>